export default __webpack_public_path__ + "static/media/ic_message.8f0704dd.svg";